const c = {
  name: "Users4",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,0C6.8,0,5,1.8,5,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C13,1.8,11.2,0,9,0z M7,4c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C7.9,6,7,5.1,7,4z"/>
		<path class="st0" d="M5,10c-2.8,0-5,2.2-5,5v5h2v-5c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3v5h2v-5c0-2.8-2.2-5-5-5H5z"/>
		<path class="st0" d="M27,4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C28.8,8,27,6.2,27,4z M31,2c-1.1,0-2,0.9-2,2
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C33,2.9,32.1,2,31,2z"/>
		<path class="st0" d="M27,10c-2.8,0-5,2.2-5,5v5h2v-5c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3v5h2v-5c0-2.8-2.2-5-5-5H27z"/>
		<path class="st0" d="M5,24c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C6.8,28,5,26.2,5,24z M9,22c-1.1,0-2,0.9-2,2
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C11,22.9,10.1,22,9,22z"/>
		<path class="st0" d="M5,30c-2.8,0-5,2.2-5,5v5h2v-5c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3v5h2v-5c0-2.8-2.2-5-5-5H5z"/>
		<path class="st0" d="M27,24c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C28.8,28,27,26.2,27,24z M31,22c-1.1,0-2,0.9-2,2
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C33,22.9,32.1,22,31,22z"/>
		<path class="st0" d="M27,30c-2.8,0-5,2.2-5,5v5h2v-5c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3v5h2v-5c0-2.8-2.2-5-5-5H27z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Users4
};
